/*
 * WasiatAds Messages
 *
 * This contains all the text for the WasiatAds component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.WasiatAds.header',
    defaultMessage: 'Siapkan Wasiat Dari Sekarang,\n Keluarga Bisa Tenang',
  },
  description: {
    id: 'app.containers.WasiatAds.description',
    defaultMessage: 'Buat wasiat dalam 1x24 jam',
  },
  cta: {
    id: 'app.containers.WasiatAds.cta',
    defaultMessage: 'Buat Sekarang'
  },
});
